import Drawer from "../../drawer/Drawer";
import { useContext } from "react";
import "./LogOutAccount.scss";
import CustomButton from "../../kits/custom-button/CustomButton";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";
import { useNavigate } from "react-router-dom";
import ShoppingCartItemContext from "../../../context/ShoppingCart/ShoppingCartItemContext.tsx";

export default function LogOutaAccount({ isOpen, setIsOpen }) {
  const navigation = useNavigate();
  const auth = useContext(AuthenticationContext);
  const { updateShoppingList } = useContext(ShoppingCartItemContext);
  return (
    <div className="parent-drawer">
      <Drawer
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        height={178}
      >
        <div className="pd-x-20 parent-drawer">
          <div className="demo-content">
            <div className="title mr-t-16 title-h3-b">خروج از حساب کاربری</div>
            <div className="message-warning mr-t-16 desc-c-l ">
              آیا می خواهید ازحساب کاربری خود خارج شوید؟
            </div>
            <div className="d-flex justify-content-between mr-t-20">
              <CustomButton
                className="btn-yes txt-t1-m"
                buttonType="primary"
                size="medium"
                onClick={() => {
                  auth.logout();
                  setIsOpen(false);
                  navigation("/user-profile");
                }}
              >
                بله
              </CustomButton>
              <CustomButton
                buttonStyle="text"
                size="medium"
                className="btn-no txt-t1-m"
                type="button"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                خیر
              </CustomButton>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
